/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon16Regular = forwardRef('DataChartBarsAUpIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12.75 4a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0V4Z" }),
        React.createElement("path", { d: "M9 5.25a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 9 5.25Z" }),
        React.createElement("path", { d: "M6.75 8a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0V8Z" }),
        React.createElement("path", { d: "M3.75 10a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0v-3Z" })));
});
